import React, { useEffect, useState } from "react";
import get from "lodash/get";

import StoryCard5 from "../../molecules/story-card5";
import StoryCard6 from "../../molecules/story-card6";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import { AdContainer } from "../../ads";
import { filterStory } from "../../helper/api";
import Separator from "../../atoms/separator";

import "./six-stories.m.css";

const SixStories = ({ collection, index }) => {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  if (!(collection && collection.items)) {
    return null;
  }
  const stories = filterStory(collection);

  if (!stories.length) {
    return null;
  }

  const desktopAdUnitId = get(collection, ["associated-metadata", "desktopAdUnitId"], null);

  const storiesCount = desktopAdUnitId ? 3 : 5;

  const AdCard = ({ id, mobile }) => {
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  return (
    <>
      <CollectionTitleHeader collection={collection} index={index} />
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          <div styleName="col1">
            {stories?.splice(0, 1).map((item, index) => (
              <StoryCard5 story={item} key={index} />
            ))}
          </div>
          <div styleName="col2">
            {stories?.splice(0, isMobile ? storiesCount + 7 : storiesCount).map((item, index) => (
              <>
                <StoryCard6 story={item} key={index} headerType={9} headerLevel={3} />
                {index === 1 ? <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} /> : null}
                {index === 5 ? <AdCard id="div-gpt-ad-1675837369401-2" mobile={mobileAdUnitId2} /> : null}
                {index === 9 ? <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} /> : null}
              </>
            ))}
            {desktopAdUnitId && !isMobile ? (
              <div styleName="ad-wrapper" className="hide-mobile">
                <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1680156228599-0" desktop={desktopAdUnitId} />
              </div>
            ) : null}
          </div>
        </div>
        <Separator />
      </div>
    </>
  );
};

export default SixStories;
